import _toConsumableArray from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { logger } from './logger';
import { parseConsentCategories } from './config-helpers';
/**
 * @returns whether or not analytics.js should be completely disabled (never load, or drop cookies)
 */
export var segmentShouldBeDisabled = function segmentShouldBeDisabled(categories, consentSettings) {
  if (!consentSettings || consentSettings.hasUnmappedDestinations) {
    return false;
  }
  // disable if _all_ of the the consented categories are irrelevant to segment
  return Object.keys(categories).filter(function (c) {
    return categories[c];
  }).every(function (c) {
    return !consentSettings.allCategories.includes(c);
  });
};
var isIntegrationCategoryEnabled = function isIntegrationCategoryEnabled(categories, userCategories) {
  var isMissingCategories = !categories || !categories.length;
  // Enable integration by default if it contains no consent categories data (most likely because consent has not been configured).
  if (isMissingCategories) {
    return true;
  }
  // Enable integration by default if it contains no consent categories data (most likely because consent has not been configured).
  var isEnabled = categories.every(function (c) {
    return userCategories[c];
  });
  return isEnabled;
};
export var shouldEnableIntegrationHelper = function shouldEnableIntegrationHelper(creationName, cdnSettings, userCategories) {
  var _ref;
  var filterSettings = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var integrationCategoryMappings = filterSettings.integrationCategoryMappings,
    shouldEnableIntegration = filterSettings.shouldEnableIntegration;
  var categories = (_ref = integrationCategoryMappings ? integrationCategoryMappings[creationName] : parseConsentCategories(cdnSettings.integrations[creationName])) !== null && _ref !== void 0 ? _ref : [];
  // allow user to customize consent logic if needed
  if (shouldEnableIntegration) {
    return shouldEnableIntegration(categories, userCategories, {
      creationName: creationName
    });
  }
  return isIntegrationCategoryEnabled(categories, userCategories);
};
/**
 * For opt-in tracking, ensure that device mode destinations that are not consented to are not loaded at all..
 * This means that the destinations are never loaded. By disabling them here,  they can never drop their own cookies or track users.
 * On the downside, it means that the user will not be able to opt-in to these destinations without a page refresh.
 */
export var filterDeviceModeDestinationsForOptIn = function filterDeviceModeDestinationsForOptIn(cdnSettings, consentedCategories, filterSettings) {
  var remotePlugins = cdnSettings.remotePlugins,
    integrations = cdnSettings.integrations;
  var integrationCategoryMappings = filterSettings.integrationCategoryMappings,
    shouldEnableIntegration = filterSettings.shouldEnableIntegration;
  var cdnSettingsCopy = _objectSpread(_objectSpread({}, cdnSettings), {}, {
    remotePlugins: _toConsumableArray(remotePlugins || []),
    integrations: _objectSpread({}, integrations)
  });
  var _shouldEnableIntegrationHelper = function _shouldEnableIntegrationHelper(creationName) {
    return shouldEnableIntegrationHelper(creationName, cdnSettings, consentedCategories, {
      integrationCategoryMappings: integrationCategoryMappings,
      shouldEnableIntegration: shouldEnableIntegration
    });
  };
  var _loop = function _loop(creationName) {
    if (!_shouldEnableIntegrationHelper(creationName)) {
      logger.debug("Disabled (opt-in): ".concat(creationName));
      cdnSettingsCopy.remotePlugins = remotePlugins === null || remotePlugins === void 0 ? void 0 : remotePlugins.filter(function (p) {
        return p.creationName !== creationName;
      });
      // remove disabled classic destinations and locally-installed action destinations
      delete cdnSettingsCopy.integrations[creationName];
    } else {
      logger.debug("Enabled (opt-in): ".concat(creationName));
    }
  };
  for (var creationName in integrations) {
    _loop(creationName);
  }
  return cdnSettingsCopy;
};